const ROLL_CALL_API_BASE_URL = process.env.REACT_APP_API_URL;


const ROLL_CALL_LOGIN = "portal/user/login";
const ROLL_CALL_EMPLOYEES_LIST = "portal/emp/getemployees";
const Bear_Token = "kbsakjdnlsajdsj";
const ROLL_CALL_ATTENDANCE = "portal/Attendance/getempattendance";
const ROLL_CALL_EMP_PROFILE = "portal/emp/getempprofile";
const ROLL_CALL_GET_HOLIDAYS = "portal/holidays/getholidays";
const ROLL_CALL_GET_EMP_LEAVES = "portal/leave/getempleaves";
const ROLL_CALL_GET_MY_TEAM = "portal/team/getmyteam";
const ROLL_CALL_GET_LEAVE_TYPES = "portal/leave/getleavetype";
const ROLL_CALL_SAVE_LEAVE = "portal/leave/saveleave";
const ROLL_CALL_GET_MY_TEAM_LEAVE = "portal/team/getmyteamleaves";
const ROLL_CALL_GET_PUNCH_TYPE = "portal/Attendance/getPunchType";
const ROLL_CALL_WRITE_SWIPE = "portal/Attendance/writeswipe";
const ROLL_CALL_LEAVE_SUMMARY = "portal/leave/getleavesummary";
const ROLL_CALL_GET_TEAM_ATTENDANCE = "portal/team/getmyteamattendance";
const ROLL_CALL_GET_UPDATE_LEAVE = "portal/leave/updateleave";
const ROLL_CALL_GET_IS_MANAGER = "portal/team/IsManager";
const ROLL_CALL_BULK_ATTENDANCE = "portal/Attendance/BulkManualAttendance";

export const getAuthToken = () => {
  return sessionStorage.getItem("authToken");
};

export const getSuperId = () => {
  return sessionStorage.getItem("superId");
};

export const getSessionData = () => ({
  token: sessionStorage.getItem("authToken"),
  superId: sessionStorage.getItem("superId"),
});

export {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_LOGIN,
  ROLL_CALL_EMPLOYEES_LIST,
  Bear_Token,
  ROLL_CALL_ATTENDANCE,
  ROLL_CALL_EMP_PROFILE,
  ROLL_CALL_GET_HOLIDAYS,
  ROLL_CALL_GET_EMP_LEAVES,
  ROLL_CALL_GET_MY_TEAM,
  ROLL_CALL_GET_LEAVE_TYPES,
  ROLL_CALL_SAVE_LEAVE,
  ROLL_CALL_GET_MY_TEAM_LEAVE,
  ROLL_CALL_GET_PUNCH_TYPE,
  ROLL_CALL_WRITE_SWIPE,
  ROLL_CALL_LEAVE_SUMMARY,
  ROLL_CALL_GET_TEAM_ATTENDANCE,
  ROLL_CALL_GET_UPDATE_LEAVE,
  ROLL_CALL_GET_IS_MANAGER,
  ROLL_CALL_BULK_ATTENDANCE,
  // PAYROLL_CALL_API_BASE_URL,
};
